import { Injectable, Inject, OnDestroy } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable, Subject, merge, of as observableOf } from "rxjs";
import { catchError, shareReplay, map, takeUntil, switchMap, mergeMap, retry } from 'rxjs/operators';
import { debugToConsole } from '../../shared/dev/debug-operator';

import { DataService, LoginService } from "./base/data.service";
import { Settings, SettingsService } from '../../settings';
import { GenericResultModel, CountyModel } from '../../models';


const API_ENDPOINT = 'api/v1/permission/';
const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root'
})
export class UserService extends DataService{
  //https://blog.thoughtram.io/angular/2018/03/05/advanced-caching-with-rxjs.html
  private cacheIsAdmin$: Observable<boolean>;//to share a single instance across all subscribers.
  private reloadIsAdmin$ = new Subject<void>();

  private cacheHasAccess$: Observable<boolean>;
  private reloadHasAccess$ = new Subject<void>();

  constructor(
    httpClient: HttpClient,
    //@Inject(LoginService) loginService
    loginService: LoginService,
    private readonly settingsService: SettingsService,
  ) {
    super(httpClient, loginService);

    //On Change userProfile:
    //                    Reload IsAdmin
    //                    Reload SubFleetId
    loginService.userProfile$
      .pipe(
        takeUntil(this.onDestroy$)
      )
      //.
      .subscribe(userProfile => {

        //if (userProfile) {
          this.forceReloadIsAdmin();
          this.forceReloadSubFleetId();

        //}
      });
  }

  public getCountries(): Observable<CountyModel[]> | any {
    return this.httpClient
      .get<any>(/*API_ENDPOINT*/ 'api/v1/common/countries', this.getRequestOptions())
      .pipe(
        map((data: GenericResultModel<CountyModel[]>) => {
          if (data && data.success) {
            return data.result;
          } 

        return observableOf(false);
        }),
        catchError(this.handleError)
      );
  }

  public hasAccess(): Observable<boolean> {
    if (!this.cacheHasAccess$) {
      const updates$ = this.reloadHasAccess$
        .pipe(
          switchMap(() => observableOf(true))
        );

      this.cacheHasAccess$ = merge(observableOf(true), updates$)
        .pipe(
          switchMap((value, index) => this.requestHasAccess()),
          shareReplay(CACHE_SIZE)
        );
    }
    return this.cacheHasAccess$;
  }

  public forceReloadSubFleetId() {
    this.reloadHasAccess$.next();//we simply propagate a ghost value causing all active Observers to be notified
  }

  private requestHasAccess(): Observable<boolean> {
    return this.httpClient
      .get<number>(API_ENDPOINT + 'has-access', this.getRequestOptions())
      .pipe(
        catchError(this.handleError)
      )
      .pipe(
        map((hasAccess: boolean) => hasAccess)
      )
  }

  public get isAdmin(): Observable<boolean> {
    if (!this.cacheIsAdmin$) {
    }
    return this.cacheIsAdmin$;
  }

  // Public facing API to force the cache to reload the data
  public forceReloadIsAdmin() {
      this.reloadIsAdmin$.next();//we simply propagate a ghost value causing all active Observers to be notified
  }

  private requestIsAdmin(): Observable<boolean> {
    return this.httpClient
      .get<boolean>(API_ENDPOINT + 'is-admin', this.getRequestOptions());
  }
}
